export const INTERACTION_FIELDS = [
    'player',
    'user',
    'buster',
    'attacker',
    'author',
    'defender',
    'sender',
    'seller',
    'buyer',
    'bailer',
    'planner',
    'initiator',
    'assister',
    'reviver',
    'recipient',
    'rater',
    'lister',
    'target',
];

export const MONEY_FIELDS = [
    'cost',
    'cost_each',
    'total_cost',
    'money_gained',
    'money_lost',
    'total_value',
    'value_each',
    'value',
    'bounty_reward',
    'money',
    'money_mugged',
    'pay',
    'received',
    'fee_balance',
    'loan_balance',
    'fee_applied',
    'amount',
    'worth'
    // 'pay',
];

export const TIME_FIELDS = [
    'duration',
    'hospital_time_increased',
    'jail_time_increased',
    'time',
];

export const PUB_USER_SELECTION = 'basic, discord, profile, timestamp';

export default {
    INTERACTION_FIELDS,
    PUB_USER_SELECTION,
    MONEY_FIELDS,
    TIME_FIELDS
}